// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3RP2l","paymentContainer":"PaymentPage_paymentContainer__fbFaF"};